"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyConfiguration = void 0;
exports.emptyConfiguration = {
    calculationParameters: {
        storageRent: 0,
        containerRent: 0,
        containerHandling: 0,
        containerTransport: 0,
        noParkingZone: 0,
        bulkyWasteDisposal: 0,
        kilometerRatePackingMaterial: 0,
        trailerThreshold: 0,
        insuranceFactor: 0,
        insuranceMinimum: 0,
        truckToll: 0,
        truckTollWithTrailer: 0,
    },
    packingMaterials: [],
    rooms: [],
    staffCategories: {
        consultant: {
            id: "consultant",
            hourlyRate: 0,
        },
        carrier: {
            id: "carrier",
            hourlyRate: 0,
        },
        teamLeader: {
            id: "teamLeader",
            hourlyRate: 0,
        },
        glassPacker: {
            id: "glassPacker",
            hourlyRate: 0,
        },
        temporaryEmployee: {
            id: "temporaryEmployee",
            hourlyRate: 0,
        },
        trainee: {
            id: "trainee",
            hourlyRate: 0,
        },
    },
    vehicles: {
        consultantCar: { id: "consultantCar" },
        furnitureTruck: { id: "furnitureTruck" },
        trailer: { id: "trailer" },
        lift: { id: "lift" },
        staffCar: { id: "staffCar" },
    },
    contractors: [],
    invoiceItems: [],
};
//# sourceMappingURL=Configuration.js.map